// ระบบกรองคำหยาบ คำต้องห้าม และคำที่ทำให้เข้าใจผิดว่าเป็น official

const PROFANITY_WORDS = [
  // คำหยาบภาษาไทย - ครอบคลุมทุกคำ
  'ควย', 'หี', 'เหี้ย', 'สัส', 'ไอ้', 'เชี่ย', 'ชาติหมา', 'ชาติชั่ว',
  'เวร', 'กาก', 'ห่า', 'เฮง', 'แม่ง', 'พ่อง', 'ดอก', 'เด้อ',
  'ส้นตีน', 'ตีนหมา', 'หมา', 'สุนัข', 'เลว', 'แย่', 'ขี้', 'ตูด',
  'เย็ด', 'มึง', 'กู', 'ไอ้สัตว์', 'ชั่ว', 'บ้า', 'โง่', 'ระยำ',
  'เหล้า', 'ยา', 'บ้าน', 'เด็กน้อย', 'เด็กโง่', 'ไอ้โง่', 'ไอ้บ้า',
  'แรด', 'ควาย', 'โคตร', 'เหี้ยน', 'เวรตัว', 'ตาย', 'ฆ่า',
  'ปากหมา', 'ปากสัตว์', 'เชี้ย', 'เชี่ยว', 'ระยำ', 'ห่วย',
  
  // คำหยาบภาษาอังกฤษ - ครอบคลุมทุกคำ
  'fuck', 'shit', 'ass', 'bitch', 'damn', 'hell', 'bastard',
  'dick', 'pussy', 'cock', 'cunt', 'slut', 'whore', 'piss',
  'fck', 'fuk', 'fuq', 'fvck', 'sh1t', 'a55', 'b1tch', 'd1ck',
  'asshole', 'motherfucker', 'bullshit', 'jackass', 'dumbass',
  'retard', 'idiot', 'moron', 'stupid', 'dumb', 'loser',
  'sex', 'porn', 'xxx', 'anal', 'rape', 'nude', 'naked',
  'boob', 'tit', 'penis', 'vagina', 'dildo', 'vibrator',
  'nigger', 'nigga', 'nazi', 'hitler', 'terrorist', 'kill', 'murder',
  'suicide', 'death', 'dead', 'die', 'bomb', 'gun', 'weapon',
  
  // คำหยาบแบบผสม/ตัวแปร
  'fuk', 'fck', 'sht', 'btch', 'dck', 'psy', 'cnt', 'whr',
  'dmn', 'hll', 'bstrd', 'ps', 'fk', 'sh', 'as', 'bt',
];

const RESERVED_WORDS = [
  // คำที่สงวนไว้สำหรับระบบ
  'admin', 'administrator', 'root', 'system', 'api', 'www',
  'mail', 'email', 'support', 'help', 'info', 'contact',
  'about', 'terms', 'privacy', 'login', 'register', 'signup',
  'signin', 'logout', 'dashboard', 'settings', 'profile',
  'account', 'billing', 'payment', 'checkout', 'cart',
  'blog', 'news', 'forum', 'community', 'docs', 'documentation',
  'download', 'upload', 'file', 'files', 'image', 'images',
  'video', 'videos', 'course', 'courses', 'lesson', 'lessons',
  'student', 'students', 'teacher', 'teachers', 'instructor',
  'test', 'testing', 'dev', 'development', 'staging', 'production',
  'cdn', 'static', 'assets', 'public', 'private', 'secure',
];

const OFFICIAL_WORDS = [
  // คำที่ทำให้เข้าใจผิดว่าเป็น official - ครอบคลุมทุกคำ
  'edumi', 'edu-mi', 'edu_mi', 'edumiofficial', 'official',
  'edumioffice', 'edumiteam', 'edumistaff', 'edumiadmin',
  'edumihelp', 'edumisupport', 'edumiservice', 'edumitech',
  'edumico', 'edumicompany', 'edumicorp', 'edumigroup',
  'edumy', 'edumee', 'edumii', 'eduми',
  
  // คำที่บ่งบอกความเป็น official/owner
  'www', 'office', 'officer', 'headquarters', 'hq', 'main', 'central',
  'staff', 'team', 'support', 'help', 'service', 'customer', 'care',
  'owner', 'founder', 'ceo', 'director', 'manager', 'president',
  'verified', 'authentic', 'real', 'true', 'original', 'genuine',
  
  // คำที่เกี่ยวกับรัฐบาล/หน่วยงาน
  'thailand', 'thai', 'bangkok', 'government', 'gov', 'official',
  'ministry', 'department', 'office', 'bureau', 'agency',
  'public', 'national', 'state', 'federal', 'royal',
  
  // แบรนด์ใหญ่ที่อาจสร้างความเข้าใจผิด
  'facebook', 'google', 'youtube', 'twitter', 'instagram',
  'line', 'tiktok', 'microsoft', 'apple', 'amazon',
  'meta', 'alphabet', 'netflix', 'spotify', 'linkedin',
  
  // คำที่เกี่ยวกับการขาย/การตลาดที่อาจทำให้เข้าใจผิด
  'sale', 'sales', 'shop', 'store', 'market', 'marketplace',
  'commerce', 'business', 'enterprise', 'corporate', 'company',
  'brand', 'trademark', 'copyright', 'patent',
];

const INAPPROPRIATE_PATTERNS = [
  // รูปแบบที่ไม่เหมาะสม
  /^[0-9]+$/, // ตัวเลขอย่างเดียว
  /^.{1,2}$/, // สั้นเกินไป (น้อยกว่า 3 ตัวอักษร)
  /^.{51,}$/, // ยาวเกินไป (มากกว่า 50 ตัวอักษร)
  /[^a-z0-9-_]/i, // มีอักขระพิเศษที่ไม่อนุญาต
  /^[-_]/, // เริ่มต้นด้วย - หรือ _
  /[-_]$/, // ลงท้ายด้วย - หรือ _
  /[-_]{2,}/, // มี -- หรือ __ ติดกัน
];

export interface ValidationResult {
  isValid: boolean;
  error?: string;
}

export function validateUsername(username: string): ValidationResult {
  if (!username || username.trim() === '') {
    return {
      isValid: false,
      error: 'กรุณากรอก Username',
    };
  }

  const normalizedUsername = username.toLowerCase().trim();

  // ตรวจสอบรูปแบบที่ไม่เหมาะสม
  for (const pattern of INAPPROPRIATE_PATTERNS) {
    if (pattern.test(normalizedUsername)) {
      if (/^[0-9]+$/.test(normalizedUsername)) {
        return { isValid: false, error: 'Username ต้องมีตัวอักษรด้วย ไม่ใช่แค่ตัวเลข' };
      }
      if (/^.{1,2}$/.test(normalizedUsername)) {
        return { isValid: false, error: 'Username ต้องมีอย่างน้อย 3 ตัวอักษร' };
      }
      if (/^.{51,}$/.test(normalizedUsername)) {
        return { isValid: false, error: 'Username ต้องไม่เกิน 50 ตัวอักษร' };
      }
      if (/[^a-z0-9-_]/i.test(normalizedUsername)) {
        return { isValid: false, error: 'Username ใช้ได้เฉพาะ a-z, 0-9, - และ _ เท่านั้น' };
      }
      if (/^[-_]/.test(normalizedUsername)) {
        return { isValid: false, error: 'Username ต้องไม่เริ่มต้นด้วย - หรือ _' };
      }
      if (/[-_]$/.test(normalizedUsername)) {
        return { isValid: false, error: 'Username ต้องไม่ลงท้ายด้วย - หรือ _' };
      }
      if (/[-_]{2,}/.test(normalizedUsername)) {
        return { isValid: false, error: 'Username ต้องไม่มี -- หรือ __ ติดกัน' };
      }
    }
  }

  // ตรวจสอบคำหยาบ
  for (const word of PROFANITY_WORDS) {
    if (normalizedUsername.includes(word)) {
      return {
        isValid: false,
        error: 'Username นี้มีคำที่ไม่เหมาะสม กรุณาเลือกชื่ออื่น',
      };
    }
  }

  // ตรวจสอบคำสงวน (exact match เท่านั้น)
  for (const word of RESERVED_WORDS) {
    if (normalizedUsername === word) {
      return {
        isValid: false,
        error: 'Username นี้ถูกสงวนไว้สำหรับระบบ กรุณาเลือกชื่ออื่น',
      };
    }
  }

  // ตรวจสอบคำที่ทำให้เข้าใจผิดว่าเป็น official
  for (const word of OFFICIAL_WORDS) {
    if (normalizedUsername.includes(word)) {
      return {
        isValid: false,
        error: 'Username นี้อาจทำให้เข้าใจผิดว่าเป็นบัญชีทางการ กรุณาเลือกชื่ออื่น',
      };
    }
  }

  return {
    isValid: true,
  };
}

export function sanitizeUsername(username: string): string {
  return username
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9-_]/g, '')
    .replace(/^[-_]+/, '')
    .replace(/[-_]+$/, '')
    .replace(/[-_]{2,}/g, '-')
    .substring(0, 50);
}
